require('./').install();



//////////////////
// WEBPACK FOOTER
// ./~/ganache-core/~/source-map-support/register.js
// module id = 190
// module chunks = 0 1 2